/**
 * "Firstname Lastname" → "Lastname Firstname" дараалалд хөрвүүлнэ
 */
export function formatName(fullName: string | undefined | null): string {
  if (!fullName) return ''
  const parts = fullName.trim().split(/\s+/)
  if (parts.length < 2) return fullName
  return `${parts[parts.length - 1]} ${parts.slice(0, -1).join(' ')}`
}
